export const colorBlank = '#2b343e';
export const colors = ['#1c6486', '#0d94ce', '#00b6ff', '#8addff', '#beedff'];
